







import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import { HsabExpenseResponse , HsabExpenseReimbursementResponse } from "@/shared/types";
import HsabExpenseReimbursementDenialReason from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseReimbursementDenialReason.vue";

@Component({
  components: { HsabExpenseReimbursementDenialReason }
})
export default class AccountHolderExpenseDenial extends Vue {

@Prop()
  expense: HsabExpenseResponse;

// this is a separate property from expense because expense.Reimbursement
// might not be the reimbursement that needs to be displayed by the denial reason component
// since it might be a reimbursement _overflow_
@Prop()
  reimbursement: HsabExpenseReimbursementResponse;
}

